import { render } from "./ResetOwnPassword.vue?vue&type=template&id=1058099c&scoped=true"
import script from "./ResetOwnPassword.vue?vue&type=script&lang=js"
export * from "./ResetOwnPassword.vue?vue&type=script&lang=js"

import "./ResetOwnPassword.vue?vue&type=style&index=0&id=1058099c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1058099c"]])

export default __exports__